export default __webpack_public_path__ + "static/media/bp-logo-green.6d170252.svg";